import { render, staticRenderFns } from "./ConsultarPlaca.vue?vue&type=template&id=3bdd4983"
import script from "./ConsultarPlaca.vue?vue&type=script&lang=js"
export * from "./ConsultarPlaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports